/**
 * resolve when first stays inside viewport
 * @param {type} el
 * @param {type} delay
 * @returns {Promise}
 */
function viewd(el, delay = 0) {
    return new Promise(resolve => {
        let timeout = null;
        const intsec_obsr = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.intersectionRatio > 0) {
                //in view
                if (timeout) {
                    return;
                }
                timeout = setTimeout(() => {
                    //call back
                    intsec_obsr.disconnect();
                    return resolve(entry.target);
                }, delay);
            } else {
                //out view
                timeout = clearTimeout(timeout);
            }
        });
        intsec_obsr.observe(el);
    });
}

function obj2Qs() {
    const obj = Object.assign(arguments[0]);
    const usp = new URLSearchParams();
    for (let name in obj) {
        urlsearchparamsAppend(usp, name, obj[name]);
    }
    return usp.toString();
}
function urlsearchparamsAppend(usp, name, val) {
    if (val === null || Number.isNaN(val) || typeof val === 'undefined') {
        return;
    } else if (val instanceof Date) {
        !isNaN(val) && usp.append(name, val.toJSON());
    } else if (Array.isArray(val)) {
        for (let i = 0; i < val.length; ++i) {
            urlsearchparamsAppend(usp, `${name}[]`, val[i]);
        }
    } else if (val instanceof Object) {
        if (!Object.keys(val).length) {
            usp.append(name, '');
            return;
        }
        for (let k in val) {
            urlsearchparamsAppend(usp, `${name}[${k}]`, val[k]);
        }
    } else {
        usp.append(name, val);
    }
}

function posiveRemainder(ipt, divisor) {
    ipt = ipt % divisor;
    if (ipt < 0) {
        ipt += divisor;
    }
    return ipt;
}

export {viewd, obj2Qs, posiveRemainder};
